<template>
    <card>
        <template #header>
            <custom-card-header :title="trans('qa.overview.header')" />
        </template>

        <div class="d-flex flex-column gap-3">
            <quality-assurance-configuration-type
                :asset-id="assetId"
                :create-url="route('quality-assurance.configurations.create', { asset_id: assetId, type: 'preventative_maintenance' })"
                :disabled="disabled"
                :empty-text="trans('qa.configuration.type.preventative_maintenance.empty_state')"
                :items="page.props.qualityAssuranceConfigurations.preventative_maintenance?.data || []"
                :title="trans('qa.configuration.type.preventative_maintenance.title')"
            />

            <quality-assurance-configuration-type
                :asset-id="assetId"
                :create-url="route('quality-assurance.configurations.create', { asset_id: assetId, type: 'asset_check' })"
                :disabled="disabled"
                :empty-text="trans('qa.configuration.type.asset_check.empty_state')"
                :items="page.props.qualityAssuranceConfigurations.asset_check?.data || []"
                :title="trans('qa.configuration.type.asset_check.title')"
            />

            <quality-assurance-configuration-type
                :asset-id="assetId"
                :create-url="route('quality-assurance.configurations.create', { asset_id: assetId, type: 'performance_data' })"
                :disabled="disabled"
                :empty-text="trans('qa.configuration.type.performance_data.empty_state')"
                :items="page.props.qualityAssuranceConfigurations.performance_data?.data || []"
                :title="trans('qa.configuration.type.performance_data.title')"
            />
        </div>
    </card>
</template>

<script setup>
import Card from '@/Components/Card.vue';
import CustomCardHeader from '@/Components/CustomCardHeader.vue';
import QualityAssuranceConfigurationType from './QualityAssuranceConfigurationType.vue';
import { usePage } from '@inertiajs/vue3';

const page = usePage();

defineProps({
    assetId: {
        type: String,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
</script>
